module.exports = __webpack_public_path__ + "img/symbol_11.a2c7aa36.png";